import { DeleteModal } from "@/components/modal/DeleteModal.tsx";
import { useStandardMutation } from "@/modules/api/useStandardMutation.ts";
import { deleteReplicaMutation, type VirtualMachineLoc } from "@/modules/compute/vmQuery.ts";
import { Trans } from "@lingui/react/macro";
import type { VirtualMachineStorageReplica } from "@warrenio/api-spec/spec.oats.gen";
import { unreachableSwitchCase } from "@warrenio/utils/unreachable";

export function VmDeleteReplicaModal({
    vm,
    replica,
}: {
    vm: VirtualMachineLoc;
    replica: VirtualMachineStorageReplica;
}) {
    const deleteMutation = useStandardMutation(deleteReplicaMutation);

    const { type } = replica;

    const description =
        type === "backup" ? (
            <Trans>Deleting a backup will permanently remove it.</Trans>
        ) : type === "snapshot" ? (
            <Trans>Deleting a snapshot will permanently remove it.</Trans>
        ) : (
            unreachableSwitchCase(type)
        );

    return (
        <DeleteModal
            inTable
            modalAction={async () => {
                await deleteMutation.mutateAsync({
                    location: vm.location,
                    body: {
                        replica_uuid: replica.uuid,
                        type: replica.type,
                    },
                });
            }}
        >
            {description}
        </DeleteModal>
    );
}
